<template>

  <el-dialog :visible.sync="visible" width="880px" append-to-body :close-on-click-modal="false" @closed="onClosed">

    <template slot="title">

      <div class="doc-dialog-header">

        <span class="doc-dialog-title">{{ dialogTitle }}</span>

        <div v-if="showViewToolbar" class="doc-dialog-actions">

          <el-button-group>

            <workflow-doc-buttons biz-type="productionSettle" :biz-id="form.id" perm="production:productionSettle" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" @done="onWorkflowDone" />

            <el-button v-if="(isAuth('production:productionSettle:update') || isAuth('production:productionSettle:save')) && form.approveStatus !== '2'" type="primary" size="small" @click="readonly = false">修改</el-button>

            <el-button v-if="isAuth('production:productionSettle:delete') && form.approveStatus !== '2'" type="primary" size="small" @click="remove">删除</el-button>

            <el-button v-if="isAuth('production:productionSettle:approve') && form.approveStatus === '2' && Number(form.subcontractAmount || 0) > 0" type="primary" size="small" @click="syncSubcontractPayables">同步委外应付</el-button>

          </el-button-group>

        </div>

      </div>

    </template>

    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">

      <el-row :gutter="10">

        <el-col :span="8"><el-form-item label="结算单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id || codeReadonly" :placeholder="codeReadonly ? '保存时按单据规则生成' : '请输入结算单号'" /></el-form-item></el-col>

        <el-col :span="8"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>

        <el-col :span="8">

          <el-form-item label="生产工单" prop="productionOrderId">

            <el-input :value="form.productionOrderCode" readonly placeholder="选择工单">

              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>

            </el-input>

          </el-form-item>

        </el-col>

      </el-row>

      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :disabled="formDisabled" /></el-form-item>

      <div v-if="cost" style="margin-bottom:12px">

        <div style="font-weight:600;margin-bottom:8px">{{ readonly && form.approveStatus === '2' ? '结算成本（已冻结）' : '成本预览（审核后冻结）' }}</div>

        <el-descriptions :column="3" border size="small">

          <el-descriptions-item label="材料">{{ money(cost.materialCost) }}</el-descriptions-item>

          <el-descriptions-item label="人工">{{ money(cost.laborCost) }}</el-descriptions-item>

          <el-descriptions-item label="委外">{{ money(cost.subcontractCost) }}</el-descriptions-item>

          <el-descriptions-item label="制造费用">{{ money(cost.overheadCost) }}</el-descriptions-item>

          <el-descriptions-item label="在制材料">{{ money(cost.wipMaterialCost) }}</el-descriptions-item>

          <el-descriptions-item label="合计">{{ money(cost.totalCost) }}</el-descriptions-item>

        </el-descriptions>

      </div>

      <el-table v-if="form.lines && form.lines.length" :data="form.lines" border size="small" :header-cell-style="headStyle">

        <el-table-column prop="lineSort" label="序" width="50" />

        <el-table-column prop="costType" label="类型" width="120" />

        <el-table-column prop="amount" label="金额" width="120" align="right" />

        <el-table-column prop="remark" label="说明" min-width="160" />

      </el-table>

    </el-form>

    <span slot="footer">

      <el-button @click="visible = false">取消</el-button>

      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>

    </span>

    <el-dialog title="选择生产工单" :visible.sync="orderDlg" width="700px" append-to-body>

      <el-table :data="orderOptions" border :header-cell-style="headStyle" @row-click="selectOrder">

        <el-table-column prop="productionOrderCode" label="工单号" min-width="140" />

        <el-table-column prop="materialCode" label="成品编码" min-width="120" />

        <el-table-column prop="orderStatus" label="状态" width="90">

          <template slot-scope="s">{{ s.row.orderStatus === '1' ? '已下达' : s.row.orderStatus === '3' ? '已完工' : (s.row.orderStatus || '') }}</template>

        </el-table-column>

      </el-table>

    </el-dialog>

  </el-dialog>

</template>



<script>

import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'



function today() {

  const d = new Date()

  const p = n => String(n).padStart(2, '0')

  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'

}



export default {

  name: 'ProductionSettleAddOrUpdate',

  components: { WorkflowDocButtons },

  data() {

    return {

      visible: false,

      readonly: false,

      orderDlg: false,
      codeReadonly: false,
      previewRequestId: 0,

      orders: [],
      ordersRequestId: 0,

      permCodes: [],

      form: { productionOrderId: '', productionOrderCode: '', bizDate: '', lines: [] },

      cost: null,

      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },

      rules: {

        bizDate: [{ required: true, message: '结算日期不能为空', trigger: 'change' }],

        productionOrderId: [{ required: true, message: '请选择生产工单', trigger: 'change' }]

      }

    }

  },

  computed: {

    finishedOrders() { return this.orders.filter(row => (row.orderStatus === '1' || row.orderStatus === '3') && row.settleStatus !== '2') },

    orderOptions() { return this.readonly ? this.orders : this.finishedOrders },

    formDisabled() { return this.readonly || String(this.form.approveStatus) === '2' },

    showViewToolbar() { return this.readonly && !!this.form.id },

    dialogTitle() {

      if (this.readonly) return '结算详情'

      return this.form.id ? '修改结算' : '新增结算'

    }

  },

  created() {

    this.loadPerms()

    this.loadOrders()

  },

  methods: {

    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'productionSettle' }).then(res => {
        if (!this.visible || this.form.id) return
        const rule = res.data || {}
        this.codeReadonly = !!rule.codeReadonly
        if (rule.previewCode) this.form.code = rule.previewCode
      }).catch(() => {})
    },

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    loadOrders(includeId) {
      const include = includeId || (this.form && this.form.productionOrderId) || ''
      const requestId = ++this.ordersRequestId
      return request.get('/production/order/ordersForBiz', {
        params: { includeProductionOrderId: include, settleOnlyUnsettled: true }
      }).then(res => { if (requestId === this.ordersRequestId) this.orders = res.data || [] })
        .catch(() => { if (requestId === this.ordersRequestId) this.orders = [] })
    },

    pickOrder() {
      this.orderDlg = true
      this.loadOrders(this.form.productionOrderId)
    },

    selectOrder(row) {
      if (!row) return
      this.form.productionOrderId = row.productionOrderId
      this.form.productionOrderCode = row.productionOrderCode || ''
      this.orderDlg = false
      this.loadPreview()
    },

    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },

    onClosed() {

      this.readonly = false

      this.orderDlg = false

      this.cost = null
      this.previewRequestId++

      this.form = { productionOrderId: '', productionOrderCode: '', bizDate: '', lines: [] }

    },

    init(idOrRow, readonly) {

      this.visible = true

      this.readonly = !!readonly

      this.cost = null
      this.previewRequestId++

      if (this.readonly && idOrRow) {

        const openView = prefill => {

          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')

          this.form = { id: prefill.id, code: prefill.code || '', bizDate, productionOrderId: prefill.productionOrderId || '', productionOrderCode: prefill.productionOrderCode || '', remark: prefill.remark || '', approveStatus: String(prefill.approveStatus || '0'), subcontractAmount: prefill.subcontractAmount || 0, lines: prefill.lines || [] }
          this.loadOrders(this.form.productionOrderId).then(() => {
            if (!this.form.productionOrderCode && this.form.productionOrderId) {
              const hit = (this.orders || []).find(o => o.productionOrderId === this.form.productionOrderId)
              if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
            }
          })

          if (String(prefill.approveStatus) === '2') {
            this.cost = { materialCost: prefill.materialAmount, laborCost: prefill.laborAmount, subcontractCost: prefill.subcontractAmount, overheadCost: prefill.overheadAmount, wipMaterialCost: prefill.varianceAmount, totalCost: prefill.totalAmount }
          } else this.loadPreview()

        }

        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow

        if (id) {

          request.get('/production/settle/info', { params: { id } }).then(res => {
            openView(res.data || (typeof idOrRow === 'object' ? idOrRow : { id }))
          }).catch(() => { openView(typeof idOrRow === 'object' ? idOrRow : { id }) })

        }

        return

      }

      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null

      this.codeReadonly = false

      this.form = { code: '', bizDate: today(), productionOrderId: (prefill && prefill.productionOrderId) || '', productionOrderCode: (prefill && prefill.productionOrderCode) || '', remark: '', lines: [] }

      this.resolveCode()
      if (this.form.productionOrderId) {
        const orderId = this.form.productionOrderId
        this.loadOrders(orderId).then(() => {
          if (!this.visible || this.form.productionOrderId !== orderId || this.form.productionOrderCode) return
          const hit = this.orders.find(order => order.productionOrderId === orderId)
          if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
        })
      }

      if (this.form.productionOrderId) this.loadPreview()

    },

    loadPreview() {

      if (!this.form.productionOrderId || this.form.approveStatus === '2') return

      const orderId = this.form.productionOrderId
      const requestId = ++this.previewRequestId
      this.cost = null

      request.get('/production/settle/preview', { params: { productionOrderId: orderId, excludeSettleId: this.form.id || '' } }).then(res => {
        if (requestId === this.previewRequestId && this.form.productionOrderId === orderId) this.cost = res.data || null
      }).catch(() => { if (requestId === this.previewRequestId) this.cost = null })

    },

    money(value) { return value != null && value !== '' ? Number(value).toFixed(2) : '0.00' },

    syncSubcontractPayables() {
      request.post('/production/settle/sync-subcontract-payables', { id: this.form.id }).then(() => {
        this.$message.success('委外应付已同步')
        this.$emit('refreshDataList')
      }).catch(() => {})
    },

    approve(pass) {

      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {

        request.post(pass ? '/production/settle/approve' : '/production/settle/unapprove', { id: this.form.id }).then(() => {

          this.$message.success(pass ? '审核成功' : '弃审成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {})

      }).catch(() => {})

    },

    remove() {

      this.$confirm('确定删除这张未审核结算单?', '提示', { type: 'warning' }).then(() => {

        request.post('/production/settle/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      }).catch(() => {})

    },

    save() {

      this.$refs.dataForm.validate(valid => {

        if (!valid) return

        request.post('/production/settle/save', {

          settleId: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: this.form.productionOrderId, remark: this.form.remark

        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      })

    }

  }

}

</script>



<style scoped>

.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }

.doc-dialog-title { font-size: 16px; font-weight: 600; }

.doc-dialog-actions .el-button { margin-left: 0; }

</style>


